import LocalizationContext from 'providers/LocalizationProvider/LocalizationContext';
import React from 'react';
import { SupportedLocale, SupportedRegion } from 'types/Supported';

const useLocalizationContext = (): { locale: SupportedLocale; region: SupportedRegion } =>
  React.useContext(LocalizationContext);

export default useLocalizationContext;
